<script module lang="ts">
  import type { ImageCardStoryblokProps } from './image-card.types';
  import type { Snippet } from 'svelte';

  export interface ImageCardProps extends ImageCardStoryblokProps {
    children?: Snippet;
  }
</script>

<script lang="ts">
  import { Card, CardImage, CardContent, CardFooter } from '@agapi/ui/card';
  import { storyblokEditable, StoryblokComponent } from '@storyblok/svelte';
  import { css } from '@agapi/ui/panda/css';
  import RichText from '../rich-text/rich-text.svelte';

  const { blok }: ImageCardProps = $props();

  console.log(blok)

  const isBackgroundImage = blok.imagePosition === 'background';
</script>

<Card
  use={[[storyblokEditable, blok]]}
  spacing="tight"
  imageBg={isBackgroundImage}
  css={{ height: 'full' }}
>

    {#if blok.imagePosition === 'top'}
      <CardImage
        src={blok.image.filename ?? ''}
        alt={blok.image.alt ?? ''}
        fit="contain"
      />
    {/if}

  {#if isBackgroundImage}
    <CardImage
      src={blok.image.filename ?? ''}
      alt={blok.image.alt ?? ''}
      fit="contain"
    />
  {/if}

  <CardContent>
    <h3 class={css({
      textStyle: 'h4',
      color: isBackgroundImage ? 'text.inverse' : 'text.heading',
      maxWidth: '100%'
    })}>
      {blok.title}
    </h3>
    <div class={css({
      textStyle: 'body.md',
      color: isBackgroundImage ? 'text.inverse.muted' : 'text.muted',
      mt: '2'
    })}>
      {#if blok.description}
        <RichText blok={{ body: blok?.description }} />
      {/if}
    </div>
  </CardContent>

  {#if blok.button?.[0]}
    <CardFooter>
      <StoryblokComponent blok={blok.button[0]} />
    </CardFooter>
  {/if}

  {#if blok.imagePosition === 'bottom'}
    <CardImage
      src={blok.image.filename ?? ''}
      alt={blok.image.alt ?? ''}
    />
  {/if}
</Card>
